import { useLayoutEffect, useRef, useSyncExternalStore } from 'react';
import { createDamagePhotoClient, type DamagePhotoClient } from '../photo-client';
import { damageAccountKey } from '../client';
import type { DamageAccount } from '../types';
import { proofStorageEvent } from '../../driver-proof/storage';
const clients = new Map<string, DamagePhotoClient>();
if (typeof window !== 'undefined') {
  window.addEventListener(proofStorageEvent, () => clients.forEach(c => void c.refreshSaved()));
  window.addEventListener('beforeunload', e => { if ([...clients.values()].some(c => c.snapshot().pending || c.snapshot().busy)) { e.preventDefault(); e.returnValue = ''; } });
}
export function useDamagePhotoClient(base: string, a: DamageAccount, begin?: () => () => void) {
  const key = damageAccountKey(base, a), live = useRef(key); live.current = key;
  useLayoutEffect(() => { live.current = key; return () => { live.current = ''; }; }, [key]);
  if (!clients.has(key)) clients.set(key, createDamagePhotoClient(base, a, begin));
  const client = clients.get(key)!; client.activate(() => live.current === key);
  const state = useSyncExternalStore(client.subscribe, client.snapshot);
  return { client, ...state, locked: state.loading || state.busy || state.blocked || !!state.pending };
}
